import React from "react";
import Field from "../../ui/Field";
import ParentsSelector from "./ParentsSelector";
import maleImg from "../../../assets/images/male.png";
import femaleImg from "../../../assets/images/female.png";
import { useCharacter } from "../../../hooks/use-character";
import { DEFAULT_FATHER, DEFAULT_MOM } from "../../../constants/parents";

interface Props {
  className?: string;
}

const Identity: React.FC<Props> = ({ className }) => {
  const {
    mode,
    handleIdentityChange,
    character: {
      identity: {
        gender,
        mother,
        father,
        tops,
        legs,
        shoes,
        firstName,
        lastName,
        heritage,
        similarity,
      },
    },
  } = useCharacter();

  if (mode === "operator") return null; // Hide this category

  return (
    <div className={`space-y-8 ${className}`}>
      {/* Nume */}
      <div className="grid grid-cols-2 gap-4">
        <Field
          label="Prenume"
          description="Introduceți prenumele"
          type="input"
          placeholder="Enter value"
          initialValue={firstName}
          onChange={(value) =>
            handleIdentityChange({ firstName: value as string })
          }
        />
        <Field
          label="Nume de familie"
          description="Introduceți numele"
          type="input"
          placeholder="Enter value"
          initialValue={lastName}
          onChange={(value) =>
            handleIdentityChange({ lastName: value as string })
          }
        />
      </div>

      {/* Parinti */}
      <ParentsSelector
        label="Parents"
        description="Alege tatăl și mama"
        selectedMother={mother || DEFAULT_MOM}
        selectedFather={father || DEFAULT_FATHER}
        onMotherChange={(value) => handleIdentityChange({ mother: value })}
        onFatherChange={(value) => handleIdentityChange({ father: value })}
      />

      {/* Gen */}
      <div className="grid items-end grid-cols-2 gap-4">
        <Field
          type="checkbox"
          label="Gender"
          description="Selectează genul personajului."
          checkboxLabel="I'm a Woman"
          checked={gender === "female"}
          onCheckedChange={() => handleIdentityChange({ gender: "female" })}
          iconSrc={femaleImg}
        />
        <Field
          type="checkbox"
          checkboxLabel="I'm a Man"
          checked={gender === "male"}
          onCheckedChange={() => handleIdentityChange({ gender: "male" })}
          iconSrc={maleImg}
        />
      </div>

      {/* Genetic — ragempkey: "heritage" */}
      <Field
        type="slider"
        label="Parametru genetic"
        description="Ajustează moștenirea genetică între mamă și tată."
        min={0}
        max={1}
        initialValue={heritage}
        onChange={(value) => handleIdentityChange({ heritage: Number(value) })}
      />

      {/* Culoarea pielii — ragempkey: "similarity" */}
      <Field
        type="slider"
        label="Culoarea Pielii"
        description="Ajustează nuanța pielii personajului."
        min={0}
        max={1}
        initialValue={similarity}
        onChange={(value) =>
          handleIdentityChange({ similarity: Number(value) })
        }
      />

      {/* Haine — RAGE MP verifica legs/tops/shoes la save */}
      <Field
        type="stepper"
        label="Pantaloni"
        description="Selectează modelul de pantaloni."
        min={0}
        max={22}
        initialValue={legs}
        onChange={(value) => handleIdentityChange({ legs: Number(value) })}
      />
      <Field
        type="stepper"
        label="Bluza"
        description="Selectează modelul de bluză."
        min={0}
        max={24}
        initialValue={tops}
        onChange={(value) => handleIdentityChange({ tops: Number(value) })}
      />
      <Field
        type="stepper"
        label="Papuci"
        description="Selectează modelul de încălțăminte."
        min={0}
        max={28}
        initialValue={shoes}
        onChange={(value) => handleIdentityChange({ shoes: Number(value) })}
      />
    </div>
  );
};

export default Identity;
